{
  "dashboard": {
    "actuatorsModal": {
      "title": "Device Control",
      "tabAll": "All",
      "tabActive": "Active ({{count}})",
      "tabFavorites": "Favourites",
      "tabTestMode": "Test Mode",
      "diagnosticMode": "Diagnostic Mode",
      "diagnosticDescription": "Run the test wizard to smoothly verify hardware communication (including PWM load tests).",
      "startTestWizard": "Start test wizard",
      "noActiveItems": "No active items.",
      "noItemsToShow": "No items to display."
    },
    "sensorDetail": {
      "tabOverview": "Overview",
      "tabHistory": "History",
      "tabCalibration": "Calibration",
      "tabConfig": "Settings",
      "idealRange": "Ideal range",
      "minimum": "Minimum",
      "maximum": "Maximum",
      "average": "Average",
      "median": "Median",
      "sensorOffline": "Sensor is offline",
      "calibrateSensor": "Calibrate sensor",
      "historyTitle": "Value over time (7 days)",
      "lastCalibration": "Last calibration",
      "never": "Never",
      "offlineCalibrationBlocked": "Sensor is offline, calibration is not possible",
      "troubleshootingTitle": "What to try:",
      "troubleshootingTip1": "Check the sensor cabling and power",
      "troubleshootingTip2": "Verify the device Wi-Fi connection",
      "troubleshootingTip3": "Restart the controller (ESP32)",
      "startNewCalibration": "Start new calibration",
      "calibrationHistory": "Calibration history",
      "twoPointCalibration": "2-point calibration",
      "noCalibrationHistory": "No calibration history",
      "generalSection": "General",
      "sensorName": "Sensor name",
      "activeLabel": "Active",
      "allowedRange": "Allowed range",
      "automationSection": "Automation",
      "calibrationSection": "Calibration",
      "createNewCycle": "Create new cycle",
      "createRule": "Create rule",
      "editRule": "Edit rule",
      "limitsAndAlarms": "Limits and alarms",
      "managedByCycle": "Managed by the growing cycle",
      "managedByRecipe": "Managed by the recipe",
      "manualLimits": "Manual limits",
      "maxLimit": "Upper limit",
      "minLimit": "Lower limit",
      "noActiveCycleDesc": "You need an active growing cycle for automatic control.",
      "noActiveCycleTitle": "No active cycle",
      "noAutomationRules": "No automation rules use this sensor.",
      "probeQuality": "Probe quality",
      "recipeRecommended": "Values are recommended by the recipe ({{phase}}).",
      "saveSettings": "Save settings",
      "slope": "Slope",
      "targetUsedForCharts": "Used to compute deviation in charts.",
      "targetValue": "Target value (ideal)",
      "unknown": "Unknown",
      "noHistoryTitle": "No measurements yet",
      "noHistoryDesc": "History will appear once the sensor collects readings."
    }
  },
  "alertManager": {
    "title": "Alert management",
    "subtitle": "View, acknowledge, and manage system alerts",
    "filtered": "Filtered",
    "resolvedHint": "(Showing resolved — max 20 days)",
    "statCards": {
      "total": "Total alerts",
      "active": "Active",
      "critical": "Critical",
      "high": "High priority",
      "resolved": "Resolved",
      "companionSuggestions": "Companion suggestions"
    },
    "filter": {
      "all": "All",
      "active": "Active",
      "acknowledged": "Acknowledged",
      "resolved": "Resolved"
    },
    "actions": {
      "refresh": "Refresh",
      "archive": "Archive",
      "archiveTitle": "Archive old resolved alerts (older than 20 days)"
    },
    "bulk": {
      "selected": "{{count}} alerts selected",
      "acknowledge": "Acknowledge",
      "resolve": "Resolve"
    },
    "table": {
      "selectAll": "Select all alerts",
      "selectAlert": "Select alert {{id}}",
      "colType": "Type",
      "colSeverity": "Severity",
      "colMessage": "Message",
      "colSensor": "Sensor",
      "colCreated": "Created",
      "colStatus": "Status",
      "colResolved": "Resolved",
      "colResolvedBy": "Resolved by",
      "colActions": "Actions",
      "viewDetail": "View detail",
      "acknowledgeAlert": "Acknowledge alert",
      "resolveAlert": "Resolve alert"
    },
    "status": {
      "resolved": "Resolved",
      "acknowledged": "Acknowledged",
      "pending": "Pending"
    },
    "empty": {
      "active": "No active alerts",
      "acknowledged": "No acknowledged alerts",
      "resolved": "No resolved alerts (last 20 days)",
      "critical": "No critical alerts",
      "high": "No high priority alerts",
      "default": "No alerts found"
    },
    "pagination": {
      "showing": "{{from}}-{{to}} of {{total}} alerts",
      "previous": "← Previous",
      "next": "Next →"
    },
    "detail": {
      "closeTitle": "Close alert detail",
      "severity": {
        "critical": "Critical",
        "high": "High priority"
      },
      "difficulty": "Difficulty: {{text}}",
      "time": "Time: {{time}}",
      "physicalAccess": "Requires physical access",
      "message": "Message",
      "resolvedInfo": "Resolved",
      "resolvedDate": "Date:",
      "resolvedBy": "Resolved by:",
      "notProvided": "Not provided",
      "device": "Device",
      "problemDescription": "Problem description",
      "solutionSteps": "Solution steps",
      "availableActions": "Available actions",
      "viewLogs": "View system logs",
      "close": "Close",
      "acknowledge": "Acknowledge",
      "resolve": "Resolve"
    },
    "archive": {
      "title": "Archive old alerts",
      "description": "Are you sure you want to archive all resolved alerts older than 20 days? Archived alerts will remain available in history but will not appear in the main view.",
      "cancel": "Cancel",
      "confirm": "Archive",
      "inProgress": "Archiving..."
    },
    "typeLabels": {
      "ph_high": "pH high",
      "ph_low": "pH low",
      "ec_high": "EC high",
      "ec_low": "EC low",
      "temp_high": "Temperature high",
      "temp_low": "Temperature low",
      "system_error": "System error",
      "network_error": "Network error",
      "pump_failure": "Pump failure",
      "sensor_failure": "Sensor failure",
      "companion_suggestion": "Companion suggestion (G-Root)"
    },
    "difficulty": {
      "easy": "Easy",
      "medium": "Medium",
      "hard": "Hard"
    },
    "resolvedBy": {
      "unknown": "Unknown",
      "auto": "Automatically (system)",
      "admin": "Admin: {{name}}",
      "user": "User: {{name}}",
      "userId": "User #{{id}}"
    },
    "companion": {
      "speciesA": "Plant A",
      "speciesB": "Plant B"
    },
    "errors": {
      "noDeviceId": "Cannot restart: device ID missing",
      "approveError": "Error approving companion bond",
      "rejectError": "Error rejecting companion bond"
    },
    "toasts": {
      "approved": "Bond {{a}} + {{b}} approved",
      "rejected": "Bond {{a}} + {{b}} rejected"
    },
    "solutionActions": {
      "calibratePh": "Run calibration",
      "restartPh": "Restart pH sensor",
      "calibrateEc": "EC calibration",
      "testDoser": "Test doser",
      "addNutrients": "Add nutrients",
      "restartFans": "Restart fans",
      "testCooling": "Test cooling",
      "restartHeating": "Restart heating",
      "testThermostat": "Test thermostat",
      "restartApi": "Restart API",
      "restartDevice": "Restart device",
      "testConnection": "Test connection",
      "restartMqtt": "Restart MQTT",
      "restartPump": "Restart pump",
      "testRelay": "Test relay",
      "replacePump": "Replace pump",
      "calibrateSensor": "Calibrate sensor",
      "restartSensor": "Restart sensor",
      "replaceSensor": "Replace sensor",
      "approveCompanion": "Approve bond",
      "rejectCompanion": "Reject",
      "viewDetail": "Plant detail"
    },
    "solutions": {
      "ph_high": {
        "description": "pH value is too high. This may be caused by improper sensor calibration, probe contamination, or genuinely high solution pH.",
        "steps": [
          "Check that the pH probe is clean and properly submerged",
          "Verify calibration using a reference solution",
          "Add pH- solution to lower the pH",
          "Wait 15-30 minutes for stabilization"
        ],
        "time": "15-30 min"
      },
      "ph_low": {
        "description": "pH value is too low. This may be caused by over-acidification of the solution or a sensor error.",
        "steps": [
          "Check pH probe condition",
          "Verify calibration",
          "Add pH+ solution to raise pH",
          "Monitor value stabilization"
        ],
        "time": "15-30 min"
      },
      "ec_high": {
        "description": "EC (conductivity) value is too high. The solution contains too many nutrients.",
        "steps": [
          "Dilute the solution with clean water",
          "Check the dosing system",
          "Verify EC probe condition",
          "Monitor values after adjustment"
        ],
        "time": "20-40 min"
      },
      "ec_low": {
        "description": "EC (conductivity) value is too low. The solution contains too few nutrients.",
        "steps": [
          "Add nutrients according to the recipe",
          "Check the dosing system",
          "Verify EC probe condition",
          "Wait for mixing"
        ],
        "time": "15-25 min"
      },
      "temp_high": {
        "description": "Solution or ambient temperature is too high. This may damage plant roots.",
        "steps": [
          "Check ventilation and cooling",
          "Verify fan operation",
          "Add cooling elements to the reservoir",
          "Reduce ambient temperature"
        ],
        "time": "30-60 min"
      },
      "temp_low": {
        "description": "Temperature is too low. This may slow plant growth.",
        "steps": [
          "Check the heating element",
          "Verify thermostat settings",
          "Insulate the reservoir",
          "Increase ambient temperature"
        ],
        "time": "20-40 min"
      },
      "system_error": {
        "description": "A system error occurred. May be caused by a software issue or communication failure.",
        "steps": [
          "Check system logs",
          "Verify network connection status",
          "Restart the problematic service",
          "If it persists, restart the device"
        ],
        "time": "5-15 min"
      },
      "network_error": {
        "description": "Network connection error. The device does not have a stable connection to the server.",
        "steps": [
          "Check WiFi signal",
          "Verify router status",
          "Check MQTT broker",
          "Restart the network connection"
        ],
        "time": "5-20 min"
      },
      "pump_failure": {
        "description": "The pump is not working correctly. It may be clogged, damaged, or have an electrical issue.",
        "steps": [
          "Check pump power supply",
          "Verify it is not clogged",
          "Check relay and switch",
          "Test the pump manually"
        ],
        "time": "15-60 min"
      },
      "sensor_failure": {
        "description": "The sensor is not returning valid data. It may be broken, poorly connected, or need calibration.",
        "steps": [
          "Check sensor wiring",
          "Clean the sensor",
          "Perform calibration",
          "If it persists, replace the sensor"
        ],
        "time": "20-45 min"
      },
      "companion_suggestion": {
        "description": "G-Root AI discovered a new potential bond between two plants based on knowledge graph analysis. Review the detail and confirm or reject.",
        "steps": [
          "Study the biological effects of the proposed bond",
          "Verify whether the result matches your experience",
          "Confirm the bond (adds to verified relationships) or reject it"
        ],
        "time": "1-2 min"
      },
      "default": {
        "description": "An unexpected error occurred. Check the system and logs for more information.",
        "steps": [
          "Check system logs",
          "Verify status of all components",
          "Restart problematic services",
          "Contact support if the issue persists"
        ],
        "time": "10-30 min"
      }
    }
  },
  "onboarding": {
    "steps": {
      "intro": "Rootify",
      "welcome": "Welcome",
      "place": "Place",
      "method": "Style",
      "plants": "Plants",
      "reservoir": "Tank",
      "area": "Area",
      "complete": "Done"
    },
    "nav": {
      "back": "Back",
      "skip": "Skip wizard",
      "next": "Next",
      "submitting": "Creating...",
      "finalize": "Finish setup",
      "goBack": "Back to: {{title}}"
    },
    "defaults": {
      "areaName": "Area 1",
      "reservoirName": "Main reservoir"
    },
    "toasts": {
      "success": "All set! You can start growing.",
      "error": "Error creating: {{message}}",
      "errorFallback": "Please try again"
    },
    "intro": {
      "subtitle": "Your personal gardening assistant for smart growing",
      "start": "Let's go!",
      "benefits": {
        "growth": {
          "title": "Track growth",
          "desc": "Clear journal and stats for your plants"
        },
        "fertilize": {
          "title": "Auto fertilizing",
          "desc": "System doses nutrients for you"
        },
        "monitor": {
          "title": "Leave it to us",
          "desc": "Alerts and parameter monitoring 24/7"
        }
      }
    },
    "welcome": {
      "title": "Welcome to Rootify!",
      "desc": "In a few minutes we will help you set up your grow. We will find out how and where you grow, and prepare everything tailored for you."
    },
    "place": {
      "title": "Where do you grow?",
      "subtitle": "Select all locations — you can choose multiple",
      "customNames": "Do you want to name your locations?",
      "empty": "Select at least one location to continue",
      "nameAriaLabel": "Name for {{name}}",
      "options": {
        "windowsill": {
          "label": "Windowsill",
          "desc": "Herbs, small plants"
        },
        "indoor_tent": {
          "label": "Grow tent",
          "desc": "Artificial lighting, controlled conditions"
        },
        "garden": {
          "label": "Garden",
          "desc": "Outdoor bed or terrace"
        },
        "community": {
          "label": "Community garden",
          "desc": "Shared space"
        },
        "greenhouse": {
          "label": "Greenhouse",
          "desc": "Covered space with natural light"
        }
      }
    },
    "method": {
      "title": "How do you grow?",
      "subtitle": "Select all methods — you can combine them",
      "empty": "Select at least one method to continue",
      "options": {
        "hydroponic": {
          "label": "Hydroponics",
          "desc": "Soil-free growing in nutrient solution",
          "features": "pH / EC monitoring · Auto dosing · Nutrient tank"
        },
        "soil": {
          "label": "Soil (classic)",
          "desc": "Traditional growing in substrate",
          "features": "Soil moisture · Air temperature · Irrigation"
        },
        "aquaponic": {
          "label": "Aquaponics",
          "desc": "Symbiosis of fish and plants in closed system",
          "features": "Aquarium + plants · pH / water temp · Fish feeding"
        }
      }
    },
    "plants": {
      "title": "What do you want to grow?",
      "subtitle": "Select plants you are interested in — we will help you set up",
      "empty": "Optional — you can skip",
      "selected_one": "Selected: {{count}} plant",
      "selected_few": "Selected: {{count}} plants",
      "selected_many": "Selected: {{count}} plants",
      "options": {
        "lettuce": "Lettuce",
        "basil": "Basil",
        "tomato": "Tomato",
        "pepper": "Pepper",
        "strawberry": "Strawberries",
        "cucumber": "Cucumbers",
        "mint": "Mint",
        "spinach": "Spinach",
        "parsley": "Parsley",
        "chili": "Chili",
        "herbs": "Herbs",
        "microgreens": "Microgreens"
      }
    },
    "reservoir": {
      "title": "Nutrient tank",
      "subtitle": "This is where you top up the nutrient solution for your plants",
      "nameLabel": "Tank name",
      "namePlaceholder": "E.g. Main reservoir",
      "volumeLabel": "Tank volume",
      "volumeTitle": "Tank volume: {{value}} l",
      "hardwareCheckbox": "Do you own Rootify hardware?",
      "hardwareDesc": "Connect the control unit to the tank",
      "hardwareConnected": "Hardware will be connected",
      "hardwareHint": "Connection can be configured in Settings after completing the wizard",
      "sizes": {
        "small": "Small",
        "medium": "Medium",
        "large": "Large"
      }
    },
    "area": {
      "title": "Growing area",
      "subtitle": "Configure plant layout in your area",
      "assignLabel": "Assign to location",
      "nameLabel": "Area name",
      "namePlaceholder": "E.g. Area 1",
      "typeLabel": "System type",
      "sizeLabel": "How many plants do you want to grow?",
      "advancedToggle": "Custom layout (advanced)",
      "rowsLabel": "Rows",
      "colsLabel": "Columns",
      "slotsCount": "slots",
      "hiddenSlots": "(-{{count}} hidden)",
      "slotsTotalLabel": "total slots",
      "clickHint": "Click squares to define an irregular shape.",
      "zigzagXHint": "Zigzag ↔ automatically shortens odd rows. ",
      "zigzagYHint": "Zigzag ↕ automatically shortens odd columns. ",
      "checkerboardHint": "Checkerboard skips every other slot. ",
      "gardenHint": "The area will be created in the first location. More areas can be added later in the Growing Areas section.",
      "batchToggle": "Create batch right away",
      "hydroTypes": {
        "nft": {
          "label": "NFT",
          "desc": "Nutrient solution flows as a thin film over roots. Ideal for lettuce and herbs."
        },
        "dwc": {
          "label": "DWC",
          "desc": "Roots submerged directly in aerated nutrient solution."
        },
        "drip": {
          "label": "Drip",
          "desc": "Drip irrigation directly to plant roots."
        },
        "ebb_flow": {
          "label": "Ebb & Flow",
          "desc": "Solution periodically floods roots then drains. Simple and reliable."
        },
        "tower": {
          "label": "Tower",
          "desc": "Vertical growing in a tiered column — saves space."
        },
        "aeroponics": {
          "label": "Aero",
          "desc": "Roots in air, nourished by nutrient mist. Advanced method."
        }
      },
      "soilTypes": {
        "bed": {
          "label": "Bed",
          "desc": "Classic bed in soil or substrate."
        },
        "soil": {
          "label": "Pot",
          "desc": "Soil pot for individual plants."
        },
        "rack": {
          "label": "Rack",
          "desc": "Multi-tier rack — vertical garden."
        },
        "other": {
          "label": "Other",
          "desc": "Custom system."
        }
      },
      "gridSizes": {
        "small": {
          "label": "Small",
          "desc": "4 slots"
        },
        "medium": {
          "label": "Medium",
          "desc": "16 slots"
        },
        "large": {
          "label": "Large",
          "desc": "30 slots"
        }
      },
      "layoutTypes": {
        "square": "Grid",
        "triangle": "Zigzag ↔",
        "zigzag_y": "Zigzag ↕",
        "checkerboard": "Checkerboard"
      }
    },
    "complete": {
      "title": "All set!",
      "placesCreated_one": "We created {{count}} location for {{methods}} growing.",
      "placesCreated_few": "We created {{count}} locations for {{methods}} growing.",
      "placesCreated_many": "We created {{count}} locations for {{methods}} growing.",
      "addPlants": "Add plants and watch them grow!",
      "settingsHint": "Devices, sensors and safety rules can be configured in Settings.",
      "goToDashboard": "Go to Dashboard"
    },
    "methodLabels": {
      "hydroponic": "hydroponic",
      "soil": "soil (classic)",
      "aquaponic": "aquaponic"
    }
  },
  "dimmer": {
    "on": "On",
    "off": "Off",
    "pumpOn": "Active",
    "pumpOff": "Stopped",
    "runTimed": "Run for",
    "turnOn": "Turn on",
    "turnOff": "Turn off"
  },
  "actuatorCard": {
    "statusError": "Error",
    "statusRunning": "Running",
    "statusOff": "Off",
    "locked": "Locked",
    "settings": "Settings",
    "history": "History",
    "runningPrefix": "Running: {{duration}}",
    "nextPrefix": "Next: {{time}}",
    "turnOn": "Turn on {{name}}",
    "turnOff": "Turn off {{name}}",
    "timeNow": "Just now",
    "timeInMoment": "In a moment",
    "timeInMinutes": "In {{count}} min",
    "timeInHours": "In {{hours}}h {{minutes}}m",
    "timeInDays": "In {{count}} days"
  },
  "sowingWidget": {
    "title": "Sow now — {{month}}",
    "tempContext": "Outside {{temp}}°C — filtered by temperature",
    "andMore": "+ {{count}} more in Plant-O-Pedia"
  },
  "interlockPanel": {
    "title": "Active interlocks",
    "none": "No active protections",
    "countBadge_one": "{{count}} protection",
    "countBadge_other": "{{count}} protections",
    "viewAll": "View all",
    "toastFired": "Interlock fired: {{key}}",
    "toastResolved": "Interlock resolved: {{key}}"
  },
  "interlockBadge": {
    "blocked": "Blocked",
    "tooltipPrefix": "Interlock: "
  },
  "sensorConfigPanel": {
    "loading": "Loading sensor configuration...",
    "readOnly": "Read only",
    "active": "Active",
    "inactive": "Inactive",
    "unitHint": {
      "unit": "Unit: {{unit}}",
      "range": "(Range: {{min}} - {{max}})",
      "unitAndRange": "Unit: {{unit}} (Range: {{min}} - {{max}})",
      "rangeOnly": "Range: {{min}} - {{max}}"
    },
    "threshold": "Threshold value:",
    "notification": "Notification",
    "calibratedAt": "Calibrated:",
    "notes": "Notes:",
    "recalibrate": "Recalibrate",
    "warningsTitle": "Warnings",
    "saving": "Saving...",
    "saveChanges": "Save changes",
    "saveParamTitle": "Save parameter {{name}}",
    "tabs": {
      "parameters": "Parameters ({{count}})",
      "alerts": "Alerts ({{count}})",
      "calibrations": "Calibrations ({{count}})"
    },
    "toasts": {
      "paramUpdated": "Parameter updated",
      "paramUpdateFailed": "Update error: {{message}}",
      "apiError": "API communication error",
      "bulkUpdated": "Parameters bulk updated",
      "bulkFailed": "Error: {{message}}",
      "bulkApiError": "Bulk update communication error",
      "exportFailed": "Cannot export configuration",
      "loadFailed": "Failed to load sensor configuration"
    }
  },
  "sensorHealthCard": {
    "title": "Sensor health",
    "statusOk": "OK",
    "statusFrozen": "Disconnected / frozen",
    "statusDrifting": "Drifting",
    "statusSaturated": "Saturated",
    "statusStale": "No data",
    "statusNoisy": "Noisy",
    "statusUnknown": "Unknown",
    "lastSeen": "Last seen",
    "stddev": "Std. dev.",
    "baselineVoltage": "Ref. voltage",
    "calibrationAge": "Calibrated {{days}} days ago"
  },
  "actions": {
    "skipToContent": "Skip to content"
  },
  "nav": {
    "main": "Main navigation",
    "menu": "Menu"
  }
}
